import { FILTER_STATUS_SENDING } from 'utils/constants/invoice';

import { InvoiceFilterType, setFilterType, setFilterValue } from 'store/models/invoices';

const updateFilterType = (filterType) => {
    return (dispatch) => {
        dispatch([
            setFilterType(filterType),
            setFilterValue(filterType === InvoiceFilterType.Status ? FILTER_STATUS_SENDING : ''),
        ]);
    };
};

export default updateFilterType;
